import { Badge, Button, Flex, Icon, Text } from '@chakra-ui/react';
import { HiOutlineSparkles } from 'react-icons/hi2';
import { FaArrowRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

import { useNovidades } from '../../hooks/useNovidades';
import { formatarData, ListaNovidades } from '.';

/** Quantos itens da ultima entrega cabem no dashboard antes do "Ver todas". */
const ITENS_NO_RESUMO = 3;

/**
 * Chamada das novidades no dashboard: a ultima entrega resumida, com o aviso de
 * quantas ainda nao foram lidas e o caminho para o mural completo. Fica na
 * primeira tela depois do login justamente para que a mudanca seja notada sem
 * depender de aviso por fora do sistema.
 */
export const PainelNovidades = () => {
	const { versoes, naoLidas } = useNovidades();
	const navigate = useNavigate();

	const ultima = versoes[0];
	if (!ultima) return null;

	const restantes = ultima.itens.length - ITENS_NO_RESUMO;

	return (
		<Flex
			direction="column"
			gap="16px"
			bg="white"
			border="1px solid"
			borderColor="mist"
			borderRadius="14px"
			boxShadow="sm"
			p={{ base: '18px', md: '22px' }}
		>
			<Flex align="center" justify="space-between" gap="12px">
				<Flex align="center" gap="10px" wrap="wrap">
					<Icon as={HiOutlineSparkles} boxSize="20px" color="brass.500" />
					<Text fontFamily="heading" fontSize="18px" fontWeight="700" textTransform="uppercase" color="ink">
						Novidades do sistema
					</Text>
					<Text fontSize="13px" fontWeight="500" color="gray.500">
						{ultima.versao} · {formatarData(ultima.data)}
					</Text>
					{naoLidas > 0 && <Badge colorScheme="blue">{naoLidas === 1 ? '1 nova' : `${naoLidas} novas`}</Badge>}
				</Flex>
				<Button
					size="sm"
					variant="ghost"
					colorScheme="blue"
					flexShrink={0}
					rightIcon={<FaArrowRight />}
					onClick={() => navigate('/dashboard/novidades')}
				>
					Ver todas
				</Button>
			</Flex>
			<Text fontSize="14px" fontWeight="400" color="gray.600" lineHeight="1.6">
				{ultima.resumo}
			</Text>
			<ListaNovidades versoes={[ ultima ]} limite={ITENS_NO_RESUMO} semCabecalho />
			{restantes > 0 && (
				<Button
					alignSelf="flex-start"
					size="sm"
					variant="link"
					colorScheme="blue"
					onClick={() => navigate('/dashboard/novidades')}
				>
					{restantes === 1 ? 'Ver mais 1 mudança desta entrega' : `Ver mais ${restantes} mudanças desta entrega`}
				</Button>
			)}
		</Flex>
	);
};
